import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMinimizeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.278 3.503a1.1 1.1 0 0 1 0 1.556l-4.622 4.622H20a1.1 1.1 0 0 1 0 2.2h-6a1.1 1.1 0 0 1-1.1-1.1v-6a1.1 1.1 0 0 1 2.2 0v3.345l4.622-4.623a1.1 1.1 0 0 1 1.556 0M4 15.881a1.1 1.1 0 0 1 0-2.2h6a1.1 1.1 0 0 1 1.1 1.1v6a1.1 1.1 0 0 1-2.2 0v-3.344l-4.622 4.622a1.1 1.1 0 1 1-1.556-1.556l4.622-4.622z",
    clipRule: "evenodd"
  }));
}
var IcMinimizeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMinimizeFill));

export { IcMinimizeFill as I };
